import { AccountBadgeSettingsDialog } from '../../../../ui/features/badge-management/components/BadgeAccountsSelectionPanel/AccountBadgeSettingsDialog';
import { AccountContext } from '../../../../ui/features/badge-management/contexts/AccountContext';
import { useAccountBadgeReissueBulkAction } from '../../../../ui/features/badge-management/hooks/useAccountBadgeReissueBulkAction';
import { useBadgingTranslation } from '../../../../ui/hooks';
import { showCustomDialog } from '@juvare/common-web-ui/DialogHelper';
import React from 'react';
export const useAccountBadgeReissueAction = (params) => {
    const { accountBadge, onSuccess } = params;
    const { extendAccountSelectionOptionComponents } = React.useContext(AccountContext);
    const { t } = useBadgingTranslation();
    const { handleReissueAccountBadges } = useAccountBadgeReissueBulkAction({ runSync: true });
    const handleReissueAccountBadge = () => {
        showCustomDialog({
            content: (close) => {
                return (React.createElement(AccountBadgeSettingsDialog, { titleText: t('badges.badgeDetails.accountBadgeTable.reissueDialog.title', {
                        accountDisplayName: accountBadge.columns.accountDisplayName,
                    }), subTitleText: t('badges.badgeDetails.accountBadgeTable.reissueDialog.description'), cancelText: t('badges.badgeDetails.accountBadgeTable.reissueDialog.cancel'), submitText: t('badges.badgeDetails.accountBadgeTable.reissueDialog.submit'), accountBadge: accountBadge, onClose: () => {
                        close();
                    }, onSubmit: (options) => {
                        handleReissueAccountBadges(accountBadge.columns.badgeId, [{ id: accountBadge.id, options }], onSuccess, close);
                        close();
                    }, extendAccountBadgeOptionComponents: extendAccountSelectionOptionComponents }));
            },
            onEscapeKeyDown: (close) => close(),
        });
    };
    return { handleReissueAccountBadge };
};
